<script lang="ts" setup>
import { useBannerUpsell } from '@composables/widgets/upsell-banner/banner-upsell.hook'
import { useAppBrand } from '@composables/tools/app-brand.hook'

import BannerUpsellCobweb from '@Atoms/UpsellBanner/BannerUpsellCobweb.vue'
import BannerUpsellCountdown from '@Atoms/UpsellBanner/BannerUpsellCountdown.vue'
import BannerUpsellTitle from '@Atoms/UpsellBanner/BannerUpsellTitle.vue'
import BannerUpsellOffer from '@Widgets/UpsellBanner/BannerUpsellOffer.vue'

defineOptions({
  name: 'BannerUpsell',
})

const { isSmartestMinds } = useAppBrand()

const {
  title,
  titleMobile,
  isVisible,
  offer,
  ctaLabel,
  href,
  countdownText,
  setSubmit,
} = useBannerUpsell()
</script>

<template>
  <div
    v-if="isVisible"
    :class="['banner-upsell', { 'banner-upsell--smartestminds': isSmartestMinds }]"
  >
    <BannerUpsellCobweb class="banner-upsell__cobweb" />
    <div class="banner-upsell__content">
      <div class="banner-upsell__head">
        <div class="banner-upsell__promo">
          <BannerUpsellTitle
            :title="title"
            :title-mobile="titleMobile"
          />
        </div>
        <BannerUpsellCountdown
          :text="countdownText"
          class="banner-upsell__countdown"
        />
      </div>
      <BannerUpsellOffer
        :offer="offer"
        :cta-label="ctaLabel"
        :href="href ?? ''"
        @click:cta="setSubmit"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/UpsellBanner/BannerUpsell.scss" />
